// Mirrors the backend PatientVisitStatusEnum, applied to `visitStatus`.
export enum PatientVisitStatusEnum {
  Started = 0,
  Completed = 1,
  Skipped = 2,
  Failed = 3,
  Changed = 4,
  AutoCompleted = 5,
}
